import React from 'react';

const PerjalananDinasTraining = () => {
  return (
    <h1>Perjalanan Dinas Training/Meeting</h1>
  );
};

export default PerjalananDinasTraining;





